<template>
    <v-col cols="12" class="mt-4">
        <div class="d-flex justify-space-between align-center mb-2">
            <span class="section-title mb-4">
                Custom Options
            </span>
        </div>

        <v-simple-table dense class="w-50" id="custom-options-table">
            <thead>
            <tr>
                <th class="text-center">Option</th>
                <th class="text-center">Option Value</th>
                <th class="text-center">Option Parameter</th>
                <th class="text-center">Available Programs (IDs)</th>
                <th class="text-center">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(option, index) in localOptions" :key="index">
                <td>
                    <v-text-field
                            v-model="option.optionName"
                            dense
                            hide-details
                            @input="onInputChange"
                    />
                </td>
                <td>
                    <v-text-field
                            v-model="option.optionValue"
                            dense
                            hide-details
                            @input="onInputChange"
                    />
                </td>
                <td>
                    <v-text-field
                            v-model="option.optionParameter"
                            dense
                            hide-details
                            @input="onInputChange"
                    />
                </td>
                <td>
                    <v-text-field
                            v-model="option.availableProgramIds"
                            dense
                            hide-details
                            @input="onInputChange"
                    />
                </td>
                <td class="text-center">
                    <v-btn icon x-small @click="removeOption(index)">
                        <v-icon color="primary" small>mdi-delete</v-icon>
                    </v-btn>
                </td>
            </tr>
            </tbody>
        </v-simple-table>
        <div class="d-flex justify-start mt-4">
            <v-btn
                    color="primary"
                    @click="addEmptyOption"
            >
                Add Custom Option
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        name: 'CustomOptionsManagerV2',
        props: {
            offerId: {
                type: Number,
                required: true
            },
            customOptions: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                localOptions: [],
                deletedOptionIds: []
            }
        },
        created() {
            this.localOptions = [...this.customOptions];
        },
        watch: {
            customOptions: {
                immediate: true,
                handler(newVal) {
                    this.localOptions = [...newVal];
                }
            }
        },
        methods: {
            addEmptyOption() {
                this.localOptions.push({
                    optionName: '',
                    optionValue: '',
                    optionParameter: '',
                    availableProgramIds: ''
                });
                this.$emit('update:customOptions', this.localOptions);
            },
            removeOption(index) {
                const option = this.localOptions[index];
                if (option.id) {
                    this.deletedOptionIds.push(option.id); 
                }
                this.localOptions.splice(index, 1);
                this.$emit('update:customOptions', this.localOptions);
                this.$emit('update:deletedIds', this.deletedOptionIds); 
            },
            onInputChange() {
                this.$emit('update:customOptions', this.localOptions);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .v-btn.primary {
        text-transform: uppercase;
        font-weight: 500;
    }
    .section-title {
        font-size: 16px !important;
        font-weight: bold !important;
    }
    #custom-options-table >>> tr:hover {
        background: transparent !important;
    }
    ::v-deep {
        .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper),
        .v-data-table__wrapper table tbody tr:hover {
            background: transparent !important;
        }
        #custom-options-table {
            thead {
                tr {
                    th {
                        background-color: #f5f5f5 !important;
                        font-weight: 500;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.87);
                        padding: 0 16px !important;
                        height: 48px;
                        text-align: left !important;
                    }
                }
            }
        }
    }
</style>